import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import {
    SolicitudViewModel,
    ParametrosNuevaSolicitudViewModel,
    TImportadorViewModel,
    TUsuarioExternoViewModel,
    TSolicitanteAdministrativoViewModel,
    TClaveCertCanariaViewModel,
    PuntoInspeccionNuevaSolicitudViewModel,
} from '../datosbasicos/datosbasicos.types';
import { TPreduaViewModel } from '../predua/predua.types';
import { GenericPostRequest } from '../../../core/_infrastructure/types/common';

///https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core

@Injectable()
export class SolicitudService {
    private paramsKey = 'importParams';
    public currentParamNuevaSolicitud = new ParametrosNuevaSolicitudViewModel();
    public currentIdSolicitud: number;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    // Persist params into localStorage or removes it if a NULL argument is given
    setParamsSolicitud(params: ParametrosNuevaSolicitudViewModel | null): boolean {
        if (params) {
            localStorage.setItem(this.paramsKey, JSON.stringify(params));
        } else {
            localStorage.removeItem(this.paramsKey);
        }
        return true;
    }

    // Retrieves the params JSON object (or NULL if none)
    getParamsSolicitud(): ParametrosNuevaSolicitudViewModel | null {
        let params: ParametrosNuevaSolicitudViewModel = new ParametrosNuevaSolicitudViewModel();
        let paramsJSON: ParametrosNuevaSolicitudViewModel;

        let i = localStorage.getItem(this.paramsKey);
        if (i) {
            paramsJSON = JSON.parse(i);

            params.EsConCF = paramsJSON.EsConCF;
            params.esNifExtranjero = paramsJSON.esNifExtranjero;
            params.esPredua = paramsJSON.esPredua;
            params.esPrevia = paramsJSON.esPrevia;
            params.esReImportacion = paramsJSON.esReImportacion;
            params.FechaCartaAutorizacion = paramsJSON.FechaCartaAutorizacion;
            params.IdPaisTraslado = paramsJSON.IdPaisTraslado;
            params.IdMedioTransporteTraslado = paramsJSON.IdMedioTransporteTraslado;
            params.IdPuntoInspeccion = paramsJSON.IdPuntoInspeccion;
            params.IdSubTipoSolicitud = paramsJSON.IdSubTipoSolicitud;
            params.IdTipoSolicitud = paramsJSON.IdTipoSolicitud;
            params.Mrn = paramsJSON.Mrn;
            params.NumCertificado = paramsJSON.NumCertificado;
            //params.Ocb = paramsJSON.Ocb;
            params.Pin = paramsJSON.Pin;
            params.tipoSolicitud = paramsJSON.tipoSolicitud;
            params.IdPaisTransitoDirecto = paramsJSON.IdPaisTransitoDirecto;
            params.IdMedioTransporteTransitoDirecto = paramsJSON.IdMedioTransporteTransitoDirecto;
            params.IdMedioTransporteTransbordo = paramsJSON.IdMedioTransporteTransbordo;
            params.IdPaisTransbordo = paramsJSON.IdPaisTransbordo;
            params.IdTipoTransbordo = paramsJSON.IdTipoTransbordo;
            params.IdPuntoInspeccionTransbordo = paramsJSON.IdPuntoInspeccionTransbordo;
            params.isPifCanarias = paramsJSON.isPifCanarias;

            return params;
        } else {
            return null;
        }
    }

    getSolicitud(id: number): Observable<SolicitudViewModel> {
        return this.http.get<SolicitudViewModel>(this.baseUrl + 'api/importacion/solicitud/' + id);
    }

    asignarSolicitud(params: HttpParams): Observable<any> {
        return this.http.get<any>(this.baseUrl + 'api/importacion/solicitud/AsignarSolicitud/', { params: params }).pipe();
    }

    isSolicitudUsuario(params: HttpParams): Observable<boolean> {
        return this.http.get<boolean>(this.baseUrl + 'api/importacion/main/IsSolicitudUsuario/', { params: params }).pipe();
    }

    getSolicitudSolo(id: number): Observable<SolicitudViewModel> {
        return this.http.get<SolicitudViewModel>(this.baseUrl + 'api/importacion/solicitud/getsolicitudbyid/' + id).pipe();
    }

    getEnvioSolicitudInspector(id: number): Observable<SolicitudViewModel> {
        return this.http.get<SolicitudViewModel>(this.baseUrl + 'api/importacion/solicitud/getenviosolicitudinspectorbyid/' + id).pipe();
    }

    getEnvioSolicitud(id: number): Observable<SolicitudViewModel> {
        return this.http.get<SolicitudViewModel>(this.baseUrl + 'api/importacion/solicitud/getenviosolicitudbyid/' + id).pipe();
    }

    getSolicitudPredua(id: number): Observable<SolicitudViewModel> {
        return this.http.get<SolicitudViewModel>(this.baseUrl + 'api/importacion/solicitud/getsolicitudpreduabyid/' + id).pipe();
    }

    getSolicitudTraslado(code: string): Observable<SolicitudViewModel> {
        return this.http.get<SolicitudViewModel>(this.baseUrl + 'api/importacion/solicitud/GetSolicitudLigeraTrasladoByCodigo/' + code).pipe();
    }

    /*--------*/

    getRegistroImportadores(dniCifNie: string): Observable<TImportadorViewModel> {
        return this.http.get<TImportadorViewModel>(this.baseUrl + 'api/importacion/solicitud/registroimportadores/' + dniCifNie).pipe();
    }

    getRegistroImportadoresNoTraces(dniCifNie: string): Observable<TImportadorViewModel> {
        return this.http.get<TImportadorViewModel>(this.baseUrl + 'api/importacion/solicitud/registroimportadoresnotraces/' + dniCifNie).pipe();
    }

    getSolicitante(id: number): Observable<TUsuarioExternoViewModel> {
        return this.http.get<TUsuarioExternoViewModel>(this.baseUrl + 'api/importacion/solicitante/' + id).pipe();
    }

    getSolicitanteAdministrativo(nif: string): Observable<TSolicitanteAdministrativoViewModel> {
        return this.http.get<TSolicitanteAdministrativoViewModel>(this.baseUrl + 'api/importacion/solicitante/grabador/' + nif).pipe();
    }

    getDatosPredua(mrn: string): Observable<TPreduaViewModel> {
        return this.http.get<TPreduaViewModel>(this.baseUrl + 'api/importacion/predua/datospredua/' + mrn).pipe();
    }

    getPcfTansbordoByPais(id: number): Observable<PuntoInspeccionNuevaSolicitudViewModel[]> {
        return this.http.get<PuntoInspeccionNuevaSolicitudViewModel[]>(this.baseUrl + 'api/importacion/solicitud/PcfTansbordoByPais/' + id).pipe();
    }

    getPcfTansbordoById(id: number): Observable<PuntoInspeccionNuevaSolicitudViewModel> {
        return this.http.get<PuntoInspeccionNuevaSolicitudViewModel>(this.baseUrl + 'api/importacion/solicitud/PcfTansbordoById/' + id).pipe();
    }

    getPuntoInspeccionNuevaSolicitudImportacion(params: HttpParams): Observable<PuntoInspeccionNuevaSolicitudViewModel[]> {
        return this.http
            .get<PuntoInspeccionNuevaSolicitudViewModel[]>(this.baseUrl + 'api/importacion/solicitud/puntosinspeccionnuevasolicitudimportacion/', {
                params: params,
            })
            .pipe();
    }

    getPuntoInspeccionImportacionSinCanarias(params: HttpParams): Observable<PuntoInspeccionNuevaSolicitudViewModel[]> {
        return this.http
            .get<PuntoInspeccionNuevaSolicitudViewModel[]>(this.baseUrl + 'api/importacion/solicitud/puntoInspeccionImportacionSinCanarias/', {
                params: params,
            })
            .pipe();
    }

    /*--------*/

    createSolicitud(solicitud: SolicitudViewModel): Observable<any> {
        return this.http.post<SolicitudViewModel>(this.baseUrl + 'api/importacion/solicitud', solicitud).pipe();
    }

    cloneSolicitudTraslado(params: HttpParams): Observable<any> {
        return this.http.get<SolicitudViewModel>(this.baseUrl + 'api/importacion/solicitud/CloneSolicitudTraslado/', { params: params }).pipe();
    }

    createSolicitudNormalFinalizaTraslado(params: HttpParams): Observable<any> {
        return this.http.get<SolicitudViewModel>(this.baseUrl + 'api/importacion/solicitud/PostedSolicitudNormalFinalizaTraslado/', { params: params }).pipe();
    }

    editSolicitud(solicitud: SolicitudViewModel): Observable<any> {
        return this.http.put<SolicitudViewModel>(this.baseUrl + 'api/importacion/solicitud', solicitud).pipe();
    }

    exportDocumentoDatosSolicitud(idSolicitud: number): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/importacion/solicitud/PostExportPdfDocumentoDatosSolicitud', idSolicitud, { observe: 'response', responseType: 'blob' })
            .pipe();
    }

    exportDocumentoResultadoInspeccion(idSolicitud: number): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/importacion/solicitud/PostExportPdfDocumentoResultadoInspeccion', idSolicitud, {
                observe: 'response',
                responseType: 'blob',
            })
            .pipe();
    }

    exportInformeChedPPTraces(chedPP: string): Observable<HttpResponse<Blob>> {
        let request = new GenericPostRequest();

        request.Value = chedPP;

        return this.http.post(this.baseUrl + 'api/importacion/solicitud/PostExportPdfTraces', request, { observe: 'response', responseType: 'blob' }).pipe();
    }

    exportDocumentoFitoSanitarioTransporte(idSolicitud: number): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/importacion/solicitud/PostExportPdfDocumentoFitosanitarioTransporte', idSolicitud, {
                observe: 'response',
                responseType: 'blob',
            })
            .pipe();
    }

    exportCertificadoExportCanarias(certificado: string, pin: number): Observable<HttpResponse<Blob>> {
        let cert = new TClaveCertCanariaViewModel();

        cert.Certificado = certificado;
        cert.Pin = pin;

        return this.http
            .post(this.baseUrl + 'api/importacion/solicitud/PostExportPdfCertificadoCanarias', cert, { observe: 'response', responseType: 'blob' })
            .pipe();
    }
}
